import React, { useState } from 'react'
import { Dialog } from 'components'
import { Button, Typography } from '@mui/material'
import { useApproveAndCreditProceedingsMutation, successSnack } from 'features'
import { useDispatch } from 'react-redux'
import { assetsFormatter } from 'formatters'
import numeral from 'numeral'

export default function ApproveAndCreditProceedingsDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    proceedingsList = [],
    successCallback = null,
    errorCallback = null,
  } = _props

  const [open, setOpen] = useState(false)

  const dispatch = useDispatch()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
  }

  const [approveAndCredit] = useApproveAndCreditProceedingsMutation()

  const total = proceedingsList.reduce((acc, item) => {
    return acc + numeral(item?.totalamount).value() || 0
  }, 0)

  function handleSubmit() {
    /**
     * payload should be structured as follow:
     *
     *  {
     *    "ProceedingList": [
     *      {
     *        "proceedingid": 19,
     *        "proceedingname": "PruebaTotals",
     *        "updatedat": "2022-08-17",
     *        "state": "p",
     *        "able": true,
     *        "totalamount": "30.00",
     *        "totalstudents": "2.00"
     *      }
     *    ]
     *  }
     */
    let payload = {
      proceeding: { proceedingid: _props.proceedingsList[0].proceedingid },
    }
    const mutation = approveAndCredit(payload)
    mutation
      .then((response) => {
        if (response.data?.message === 'aproved') {
          dispatch(
            successSnack({
              message: `Lote autorizado para acreditación`,
            })
          )
          if (successCallback) successCallback()
          closeDialog()
        }
      })
      .catch((error) => {
        if (errorCallback) errorCallback()
      })
  }

  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <Dialog
          open={open}
          handleClose={closeDialog}
          primaryButtonText="Si, autorizar" //Label of the primary button
          secondaryButtonText="Cancelar" // Label of the cancel button
          title={'Autorizar lote'} // 'Dialog title'
          message={`¿Estás seguro de autorizar el lote ${proceedingsList[0].proceedingname}.\nAl aprobarlo se generarán y acreditarán los créditos  en las cuentas de los usuarios.`}
          onSubmit={handleSubmit} // Form submit action
        >
          <div className="inline-block w-auto p-4 rounded-md border-2 border-primary">
            <Typography variant="body1" className="">
              Total de activos:{' '}
              <Typography variant="h3" component="span">
                {assetsFormatter(total)}
              </Typography>
            </Typography>
          </div>
        </Dialog>
      )}
    </>
  )
}
